import React, { Fragment } from "react";

export function getCalendarEntryViewTooltipText(
    {
        entryTypeName = '',
        projectName = '',
        phaseStatusName = ''
    }): JSX.Element | null {
    if (projectName) {
        return (
            <Fragment>
                <div>{projectName}</div>
                {phaseStatusName && <div>{phaseStatusName}</div>}
            </Fragment>
        );
    }

    if (entryTypeName) {
        return <span>{entryTypeName}</span>;
    }

    return null;
}
